import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NgxEditorComponent,
  NgxEditorMenuComponent,
  NgxEditorModule,
} from 'ngx-editor';

@NgModule({
  imports: [
    CommonModule,
    NgxEditorModule.forRoot({
      locals: {
        bold: 'Bold',
        italic: 'Italic',
        code: 'Code',
        blockquote: 'Blockquote',
        underline: 'Underline',
        strike: 'Strike',
        bullet_list: 'Bullet List',
        ordered_list: 'Ordered List',
        heading: 'Heading',
        h1: 'Header 1',
        h2: 'Header 2',
        h3: 'Header 3',
        h4: 'Header 4',
        h5: 'Header 5',
        h6: 'Header 6',
        align_left: 'Left Align',
        align_center: 'Center Align',
        align_right: 'Right Align',
        align_justify: 'Justify',
        text_color: 'Text Color',
        background_color: 'Background Color',
        url: 'URL',
        image: 'Image',
      },
    }),
  ],
  exports: [
    NgxEditorComponent,
    NgxEditorMenuComponent,
  ],
})
export class EditorModule {}